module.exports = __webpack_public_path__ + "static/media/label-2.00fa714e.svg";